module.exports = __webpack_public_path__ + "img/watermark.1a8ec49e.svg";